if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

  constructor() {

    super();

    this.slider = this.querySelector('[data-js-slider]');
    this.content = this.querySelectorAll('.announcement');
    this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
    this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

    this.index = 0;
    this.length = this.content.length;
    this.autoSlideInterval = null;  // new interval variable
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.changeSlide('next');
      });
    }
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.changeSlide('prev');
      });
    }

    // start the auto slide
    this.startAutoSlide();
  }

  // new method to start auto slide
  startAutoSlide() {
    this.autoSlideInterval = setInterval(() => {
      this.changeSlide('next');
    }, 5000); // adjust this value according to the desired delay (in ms)
  }

  // new method to stop auto slide
  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  changeSlide(direction) {
    if (direction == 'next') {
      this.index++;
      if (this.index == this.length) { // If we've reached the end...
        this.index = 0;                // ...reset back to the first announcement.
      }
    } else if (direction == 'prev') {
      this.index--;
      if (this.index < 0) { // If we've gone past the first announcement...
        this.index = this.length - 1; // ...go to the last announcement.
      }
    }

    this.slider.scrollTo({
      top: 0,
      left: this.content[this.index].offsetLeft,
      behavior: 'smooth'
    });
  }

  disconnectedCallback() {
    // new cleanup for when the element is removed
    this.stopAutoSlide();
  }

}

if (typeof customElements.get('announcement-bar') == 'undefined') {
  customElements.define('announcement-bar', AnnouncementBar);
}

}